export default __webpack_public_path__ + "static/media/red-minus.30c7089e.svg";